// Formatters for Dubai locale, DD-MM-YYYY dates, AED currency
// Dates are treated as pure calendar dates (no timezone) to avoid off-by-one issues.

function parseDateParts(iso) {
  if (!iso) return null;
  const s = String(iso).slice(0, 10);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (!m) return null;
  return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]) };
}

export function formatDate(iso) {
  const p = parseDateParts(iso);
  if (!p) return iso || "";
  return `${String(p.d).padStart(2, "0")}-${String(p.mo).padStart(2, "0")}-${p.y}`;
}

export function formatAED(amount) {
  const n = Number(amount || 0);
  return `AED ${n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function daysBetween(iso) {
  const p = parseDateParts(iso);
  if (!p) return null;
  const target = new Date(p.y, p.mo - 1, p.d);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((target - today) / (1000 * 60 * 60 * 24));
}

export function toIsoDate(date) {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function fromIsoDate(iso) {
  const p = parseDateParts(iso);
  if (!p) return undefined;
  return new Date(p.y, p.mo - 1, p.d);
}

export function deadlineTone(deadlineIso, status) {
  if (status === "Completed") return "green";
  const d = daysBetween(deadlineIso);
  if (d === null) return "slate";
  if (d < 0) return "red";
  if (d <= 3) return "orange";
  if (d <= 7) return "yellow";
  return "slate";
}

const MONTH_NAMES_SHORT = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

export function periodLabel(rp) {
  if (!rp || !rp.kind || rp.kind === "none") return "—";
  if (rp.kind === "monthly" && rp.month && rp.year) {
    return `${MONTH_NAMES_SHORT[rp.month - 1]} ${rp.year}`;
  }
  if (rp.kind === "quarterly" && rp.quarter && rp.year) {
    return `Q${rp.quarter} ${rp.year}`;
  }
  if (rp.kind === "custom") {
    return `${formatDate(rp.start_date)} → ${formatDate(rp.end_date)}`;
  }
  return "—";
}

export function roleLabel(r) {
  const map = {
    administrator: "Administrator",
    partner: "Partner",
    manager: "Manager",
    responsible_person: "Responsible Person",
  };
  return map[r] || r;
}
